import { render, staticRenderFns } from "./AlbumLibrary.vue?vue&type=template&id=1c786b2d"
import script from "./AlbumLibrary.vue?vue&type=script&lang=ts"
export * from "./AlbumLibrary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports